import { render, staticRenderFns } from "./PaymentsFormAccount.vue?vue&type=template&id=535e1ec4"
import script from "./PaymentsFormAccount.vue?vue&type=script&lang=js"
export * from "./PaymentsFormAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports